import React, { Fragment, isValidElement, cloneElement, useCallback } from 'react';
import cn from 'classnames';
import { Icon } from '../Icon';
require("./Tag.css");
var styles = {
  "Root": "Tag-module-Root_3mI",
  "Label": "Tag-module-Label_2i0",
  "AddonBefore": "Tag-module-AddonBefore_3KM",
  "AddonAfter": "Tag-module-AddonAfter_1bF",
  "ActionRemove": "Tag-module-ActionRemove_3Oj",
  "ActionPrimary": "Tag-module-ActionPrimary_1kA",
  "IconRemove": "Tag-module-IconRemove_2XB",
  "mSize": "Tag-module-mSize_1tH",
  "defaultTheme": "Tag-module-defaultTheme_yWz",
  "hasAction": "Tag-module-hasAction_2Ug",
  "checked": "Tag-module-checked_1zp",
  "disabled": "Tag-module-disabled_Mwo",
  "outlinedVariant": "Tag-module-outlinedVariant_3QN"
};
export const Tag = ({
  'aria-hidden': ariaHidden,
  'aria-label': ariaLabel,
  addonAfter,
  addonBefore,
  ariaLabelRemove = 'Удалить',
  checked = false,
  className,
  controlRef,
  disabled = false,
  id,
  innerRef,
  label,
  linkComponent = 'a',
  onClick,
  onRemove,
  size = 'm',
  style = {},
  target,
  theme = 'default',
  to,
  variant = 'contained'
}) => {
  const handleRemove = useCallback(e => {
    if (onRemove) {
      onRemove(e, id);
    }
  }, [onRemove, id]);
  let ActionPrimary = Fragment;
  let actionPrimaryProps = {};
  if (onClick) {
    ActionPrimary = 'button';
    actionPrimaryProps = {
      ...(checked && {
        'aria-pressed': checked
      }),
      onClick,
      id,
      'aria-label': ariaLabel || label,
      className: cn(styles.ActionPrimary)
    };
  }
  if (to) {
    ActionPrimary = linkComponent;
    actionPrimaryProps = {
      ...(checked && {
        'aria-pressed': checked
      }),
      'aria-label': ariaLabel || label,
      className: cn(styles.ActionPrimary),
      href: to,
      id,
      target
    };
  }
  return /*#__PURE__*/React.createElement("div", {
    "aria-hidden": ariaHidden,
    style: style,
    className: cn(styles.Root, {
      [styles.checked]: checked,
      [styles.disabled]: disabled,
      [styles.hasAction]: Boolean(Object.keys(actionPrimaryProps).length)
    }, styles[`${size}Size`], styles[`${variant}Variant`], styles[`${theme}Theme`], className),
    ref: innerRef || controlRef
  }, /*#__PURE__*/React.createElement(ActionPrimary, actionPrimaryProps, addonBefore && /*#__PURE__*/isValidElement(addonBefore) && /*#__PURE__*/cloneElement(addonBefore, {
    className: cn(styles.AddonBefore)
  }), label && /*#__PURE__*/React.createElement("span", {
    className: cn(styles.Label)
  }, label), addonAfter && /*#__PURE__*/isValidElement(addonAfter) && /*#__PURE__*/cloneElement(addonAfter, {
    className: cn(styles.AddonAfter)
  })), onRemove && /*#__PURE__*/React.createElement("button", {
    onClick: handleRemove,
    className: cn(styles.ActionRemove),
    "aria-label": ariaLabelRemove
  }, /*#__PURE__*/React.createElement(Icon, {
    name: 'close',
    className: cn(styles.IconRemove),
    size: "s",
    "aria-hidden": true
  })));
};
if (process.env.NODE_ENV !== 'production') {
  Tag.displayName = 'Tag';
}